module.exports = __webpack_public_path__ + "static/img/yqdw.68cefcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/yqdw.png
// module id = A9oF
// module chunks = 0